import { SearchQuery } from "shared/data/reducers/types/storage";
import { HotelOfferDetail } from "shared/types/hotels";

const filterHotelName = (searchQuery: SearchQuery) => (
  hotelOffer: HotelOfferDetail
): boolean => {
  if (!searchQuery.hotelName) {
    return true;
  }

  if (!hotelOffer?.HotelDescription.Name?.$t) {
    return false;
  }

  return searchQuery.hotelName === hotelOffer.HotelDescription.Name.$t;
};

export default filterHotelName;
